import { Reveal } from "@/components/shared/Reveal";
import { cn } from "@/lib/utils";

export function SectionHeading({ eyebrow, title, sub, align = "center", className }) {
  const isCenter = align === "center";
  return (
    <Reveal
      className={cn(
        "max-w-2xl",
        isCenter ? "mx-auto text-center" : "text-left",
        className
      )}
    >
      {eyebrow && (
        <div
          className={cn(
            "mb-3 flex items-center gap-2",
            isCenter && "justify-center"
          )}
        >
          <span className="h-px w-6 bg-gold" />
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">
            {eyebrow}
          </span>
          <span className="h-px w-6 bg-gold" />
        </div>
      )}
      <h2 className="font-heading text-3xl font-semibold leading-tight text-navy sm:text-4xl lg:text-5xl text-balance">
        {title}
      </h2>
      {sub && (
        <p className="mt-4 text-sm leading-relaxed text-navy/65 sm:text-base">
          {sub}
        </p>
      )}
    </Reveal>
  );
}
